import { AbstractControl } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';

/**
 * 
 * @param control Control that has the validatior defined
 * @param form Complete form
 * @param options A validation function specific option object. Example: 
 * @returns true if validation passed. An object with the validation id and a message property inside if failed. Example: { "date": { message: "Something went wrong"}}
 */
export function monthFormatValidator(control: AbstractControl, form: FormlyFieldConfig, options: any = {}) {
  const model = control.value;
  let formattedDate: any;
  let monthformat: any; 

  if (!model) {
    return null; // Field is empty, no validation required.
  }
  if (control.value.length > 3) {
    try {
      let regex =/[ .\-\\/]/;
      let modelValue = model.match(regex) ? model : model.slice(0,2)+ ' '+model.slice(2);
      let input = modelValue.split(regex);
      let month = "";
      let year = "";
      if(input[0]?.length > 2) {
        let temp = new Date(Date.parse(input[0] +" 1, 2012")).getMonth()+1;
        month = ("0"+ temp).slice(-2); 
      }else{
          month = input[0];
      }
      if(input[1]?.length === 2) {
        year = input[1] < 50 ? "20" + input[1] : "19" + input[1];  
      }else{
        year = input[1]; 
      }
      formattedDate = month + '/01/'+ year;
      monthformat = month + '/' + year;
      if (!/^([1-9]|0[1-9]|1[012])[- //.](\d\d\d\d)$/.test(monthformat)) {
        return {
          'dateFormat': {
            message: 'Please enter date as mm/yyyy'
          }
        };
      }
      const currentDate = new Date();
      const enteredDate = new Date(formattedDate);
      if (monthformat !== control.value) control.patchValue(monthformat, { ...options, emitEvent: false, onlySelf: true });
      // when options.condition === ">" coming from template
      if (options.condition && options.condition === ">") {
        if (enteredDate > currentDate) {
          return {
            'dateFormat': {
              message: "provide today's date or a date prior to today."
            }
          };
        }
      } else if (options.condition && options.condition === "<>") {// when options.condition === "<>" coming from template

        // when fromDate and toDate coming from template
        if (options.fromDate && options.toDate) {
          const fromDate = new Date(options.fromDate.slice(0, 2) + "/01/" + options.fromDate.slice(options.fromDate.length - 4));
          const fromYear = fromDate.getFullYear();
          
          // when toDate is today date.
          if (options.toDate === "todayDate") {
            const toDate = currentDate;
            if (fromDate <= enteredDate && enteredDate >= toDate) {
              return {
                'dateFormat': {
                  message: "Please enter a date between" + " " + fromYear + " " + "and today's date."
                }
              };
            }
            if (fromDate >= enteredDate && enteredDate <= toDate) {

              return {
                'dateFormat': {
                  message: "Please enter a date between" + " " + fromYear + " " + "and today's date."
                }
              };
            }
          }

          // when toDate is specific date.
          if (options.toDate !== "todayDate") {
            const toDate = new Date(options.toDate.slice(0, 2) + "/01/" + options.toDate.slice(options.toDate.length - 4));
            if (fromDate < enteredDate && enteredDate > toDate) {
              return {
                'dateFormat': {
                  message: "Please enter a date between" + " " + options.fromDate + " " + "and" + " " + options.toDate + "."
                }
              };
            }
            if (fromDate > enteredDate && enteredDate < toDate) {
              return {
                'dateFormat': {
                  message: "Please enter a date between" + " " + options.fromDate + " " + "and" + " " + options.toDate + "."
                }
              };
            }
          }

        }
      }

    } catch (e) {
      console.error(e);
    }
  }

  if (!control.value || !/^([1-9]|0[1-9]|1[012])[- //.](\d\d\d\d)$/.test(monthformat)) {
     return {
      'dateFormat': {
        message: 'Please enter date as mm/yyyy'
      }
    };
  }

  return null; // Date is valid.
}
